import { getTruncatedName } from "../../../Helper/Formatters/TextFormatter";

export const isObject = (item) => {
    return item && typeof item === "object" && !Array.isArray(item);
};

export const deepMerge = (target, source) => {
    const output = { ...target };
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, { [key]: source[key] });
                } else {
                    output[key] = deepMerge(target[key], source[key]);
                }
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
};

export const getDefaultChartConfig = (categories, xAxisMax, fullAlertNames, handleDataPointClick) => {
    return {
        chart: {
            id: undefined,
            type: "bar",
            height: 300,
            toolbar: { show: false },
            zoom: { enabled: false },
            events: { dataPointSelection: handleDataPointClick },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: "16px",
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    position: 'top',
                    maxItems: 100,
                    hideOverflowingLabels: false,
                    orientation: 'horizontal',
                    total: {
                        enabled: true,
                        offsetX: 10,
                        offsetY: 0,
                        formatter: function (val) {
                            return val;
                        },
                        style: {
                            color: '#494949',
                            fontSize: '12px',
                            fontFamily: 'Roboto',
                            fontWeight: 400,
                            lineHeight: '16px'
                        }
                    }
                }
            },
        },
        xaxis: {
            categories: categories,
            max: xAxisMax,
            labels: {
                show: false,
                style: { colors: "#494949", fontSize: "12px" }
            },
            title: { text: "" },
            axisTicks: { show: false, color: "#E0E0E0" },
            axisBorder: { show: false, color: "#E0E0E0" },
        },
        yaxis: {
            labels: {
                style: { colors: "#2E2E2E", fontSize: "14px", fontWeight: 400 },
                maxWidth: '30%',
                align: "left",
                offsetX: 0,
                formatter: function (value) {
                    return getTruncatedName(value, 40, 40, 0);
                },
            },
            axisBorder: { show: false },
        },
        grid: {
            show: false,
            borderColor: "#F0F0F0",
            padding: { left: 16, right: 0, top: -10, bottom: 0 },
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: false } },
        },
        stroke: { show: false },
        tooltip: {
            shared: true,
            followCursor: false,
            intersect: false,
            x: {
                formatter: function (val, opts) {
                    const index = opts?.dataPointIndex;
                    if (index !== undefined && fullAlertNames && fullAlertNames[index]) {
                        return fullAlertNames[index];
                    }
                    return val;
                },
            },
        },
        states: {
            active: { filter: { type: 'none' } },
        },
    };
};
